<template>
  <section id="page-top" class="light">
    <div class="container">

      <div id="hamburger" class="mobile">
        <svg width="24px" height="24px" viewBox="0 0 86 80.041">
          <path fill="#FFFFFF"
                d="M81.82,0H4.179C1.87,0,0,2.11,0,4.712v6.999c0,2.603,1.87,4.713,4.179,4.713H81.82
                c2.308,0,4.18-2.11,4.18-4.713V4.712C86,2.11,84.128,0,81.82,0"></path>
          <path fill="#FFFFFF"
                d="M81.82,31.808H4.179C1.87,31.808,0,33.918,0,36.52v6.999c0,2.604,1.87,4.713,4.179,4.713H81.82
                c2.308,0,4.18-2.109,4.18-4.713V36.52C86,33.918,84.128,31.808,81.82,31.808"></path>
          <path fill="#FFFFFF"
                d="M81.82,63.617H4.179C1.87,63.617,0,65.726,0,68.329v6.999c0,2.603,1.87,4.713,4.179,4.713H81.82
                c2.308,0,4.18-2.11,4.18-4.713v-6.999C86,65.726,84.128,63.617,81.82,63.617"></path>
        </svg>
      </div>
      <a href="/">
        <logo layout="horizontal" class="desktop"></logo>
      </a>
      <a href="/">
        <logo layout="vertical" class="mobile"></logo>
      </a>
      <main-menu></main-menu>

      <ul id="additional-menu">
        <li>
          <search></search>
        </li>
        <li>
          <cart></cart>
        </li>
      </ul>

    </div>
    <alerts></alerts>
  </section>

</template>
<script>
  import Logo from './Graphics/Logo'
  import Search from './Search/Search'
  import MainMenu from './MainMenu'
  import Cart from './Cart/Cart'
  import _ from 'lodash'
  import $ from 'jquery'
  import store from "./../store/index"
  import Alerts from "./Blocks/Alerts"

  export default {
    name: 'PageTop',
    components: {Logo, MainMenu, Search, Cart, Alerts},
    mounted() {
      // ładujemy koszyk
      store.dispatch('loadCart');
      // ładujemy dostępne formy wysyłki i płatności
      store.dispatch('loadExtensions');

      let that = this;
      $(document).ready(() => {

        $(window).resize(() => {
          that.windowResize();
        });

        $('#hamburger').on('click', () => {
          $('#main-menu').addClass('show');

        });
        $('#menu-toggle').on('click', () => {
          $('#main-menu').removeClass('show');
        });

        // globalny event zmiany na wersję desktop
        $(document).on('switchToDesktop', () => {
          $('#main-menu').roll('off');
          $('.accordion').removeClass('show');
          $('#main-menu li.tree ').on('mouseover', () => {
            $('#overlay').css('display', 'block')
          });
          $('#main-menu li.tree').on('mouseout', () => {
            $('#overlay').css('display', 'none');
          });
          $('#menu-toggle').off('click');
          $('.level-0').removeAttr('style');
          $('.level-1').removeAttr('style');
          $(window).on('scroll', _.throttle(that.windowScroll, 20));
        });

        // globalny event zmiany na wersję mobilną
        $(document).on('switchToMobile', function () {
          $('#main-menu').roll({speed: 200});
          $('#main-menu li.tree ').off('mouseover');
          $(window).off('scroll');
          $('.fixed-top').css('background-position-y', 0);
        });

        env.mobileMode = ($(window).width() >= env.mobileTreshold);
        $(window).trigger('resize');
      });

    },
    methods: {
      windowResize() {
        let window_width = $(window).width();

        // flaga mobilna ale ekran duży
        if (window.env.mobileMode && window_width >= window.env.mobileTreshold) {
          window.env.mobileMode = false;
          $(document).trigger('switchToDesktop');

        }

        // flaga nie mobilna ale ekran mały
        if (!window.env.mobileMode && window_width < window.env.mobileTreshold) {
          window.env.mobileMode = true;
          $(document).trigger('switchToMobile');

        }
      },
      windowScroll() {
        let switchMenuAtPosition = 250;
        let pageTop = $('#page-top');
        let st = $(window).scrollTop();
        let speed = -0.3;
        $('.fixed-top').css('background-position-y', (speed * st) + 'px');

        // podniesienie menu na scrolla
        /*
        if(st < 20) pageTop.css('top', (st * -1)  + 'px');
        else pageTop.css('top', '-20px');
        */
        if (st > switchMenuAtPosition && pageTop.hasClass('light')) {
          pageTop.removeClass('light')
        }
        else if (st <= switchMenuAtPosition && !pageTop.hasClass('light')) {
          pageTop.addClass('light')
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PageTop.vue